import type { IJsonModel } from 'flexlayout-react';

export const wallFormingModelJson: IJsonModel = {
    global: {
        tabEnableClose: false,
        tabSetEnableSingleTabStretch: false,
        tabSetEnableTabStrip: false,
        tabSetEnableDrop: false,
        tabEnableDrag: false,
    },
    layout: {
        type: 'row',
        weight: 100,
        children: [
            {
                type: 'tabset',
                weight: 100,
                id: 'content-tab',
                enableTabStrip: false,
                children: [
                    {
                        type: 'tab',
                        name: '',
                        component: 'content',
                    },
                ],
            },
        ],
    },
};